import React from 'react';

import { COLORS, Text } from '@clutter/clean';

import tracking from '@images/illustrations/location_truck_tracking.svg';
import moverPackingBoxes from '@images/illustrations/mover_packing_boxes.svg';
import moversWithTv from '@images/illustrations/movers_with_tv_small.svg';
import truck from '@images/illustrations/moving_truck_small.svg';
import tape from '@images/illustrations/tape_multi_small.svg';
import unlimitedMaterialsBoxes from '@images/illustrations/unlimited_materials_boxes.svg';

export type WhiteGloveValueProps = {
  title: React.ReactNode;
  values: Array<{ icon: string; description: string }>;
};

export const basicBundleValueProps = (
  isMobile: boolean,
): WhiteGloveValueProps => ({
  title: 'Includes',
  values: isMobile
    ? [
        {
          icon: truck,
          description: 'Truck, dollies, and blankets',
        },
        { icon: moversWithTv, description: 'Trained professional movers' },
      ]
    : [
        {
          icon: truck,
          description: 'Truck, dollies, and blankets',
        },
        { icon: moversWithTv, description: 'Trained professional movers' },
        {
          icon: tracking,
          description: 'Real-time GPS tracking',
        },
      ],
});

export const fullServiceBundleValueProps = (
  isMobile: boolean,
): WhiteGloveValueProps => ({
  title: (
    <>
      <Text color={COLORS.panther}>Standard</Text> plus...
    </>
  ),
  values: isMobile
    ? [
        {
          icon: tape,
          description: 'Unlimited packing supplies for a flat fee',
        },
        {
          icon: unlimitedMaterialsBoxes,
          description: 'Full-service packing and unpacking',
        },
      ]
    : [
        {
          icon: tape,
          description: 'Unlimited packing supplies for a flat fee',
        },
        {
          icon: unlimitedMaterialsBoxes,
          description: 'Full-service packing and unpacking',
        },
        {
          icon: moverPackingBoxes,
          description: 'Extra stop, if needed',
        },
      ],
});
